import { useContext } from 'react'
import { AIAgentContext } from '../contexts/aiAgentContext'

export default function useAIAgentPin() {
  const context = useContext(AIAgentContext)

  if (!context) {
    throw new Error('useAIAgentPin must be used within AIAgentProvider.')
  }

  return context
}
